export var STATUS_CODE;
(function (STATUS_CODE) {
    STATUS_CODE[STATUS_CODE["SEE_ORDER_DETAILS"] = 100] = "SEE_ORDER_DETAILS";
    STATUS_CODE[STATUS_CODE["PROCESSING"] = 101] = "PROCESSING";
    STATUS_CODE[STATUS_CODE["SHIPPED"] = 102] = "SHIPPED";
    STATUS_CODE[STATUS_CODE["IN_TRANSIT"] = 103] = "IN_TRANSIT";
    STATUS_CODE[STATUS_CODE["ATTEMPTED"] = 104] = "ATTEMPTED";
    STATUS_CODE[STATUS_CODE["DELIVERED"] = 105] = "DELIVERED";
    STATUS_CODE[STATUS_CODE["BACKORDERED"] = 106] = "BACKORDERED";
    STATUS_CODE[STATUS_CODE["WORK_ORDER_CANCELED"] = 107] = "WORK_ORDER_CANCELED";
    STATUS_CODE[STATUS_CODE["MAJOR_APPLIANCE_ON_SCHEDULE"] = 108] = "MAJOR_APPLIANCE_ON_SCHEDULE";
    STATUS_CODE[STATUS_CODE["OUT_FOR_DELIVERY"] = 109] = "OUT_FOR_DELIVERY";
    STATUS_CODE[STATUS_CODE["DELIVERY_ATTEMPTED"] = 110] = "DELIVERY_ATTEMPTED";
    STATUS_CODE[STATUS_CODE["BODFS_ON_SCHEDULE"] = 111] = "BODFS_ON_SCHEDULE";
    STATUS_CODE[STATUS_CODE["ON_ITS_WAY_TO_STORE"] = 130] = "ON_ITS_WAY_TO_STORE";
    STATUS_CODE[STATUS_CODE["READY_FOR_PICKUP"] = 131] = "READY_FOR_PICKUP";
    STATUS_CODE[STATUS_CODE["PREPARING_FOR_PICKUP"] = 132] = "PREPARING_FOR_PICKUP";
    STATUS_CODE[STATUS_CODE["CANCELED"] = 140] = "CANCELED";
    STATUS_CODE[STATUS_CODE["RETURNED"] = 150] = "RETURNED";
    STATUS_CODE[STATUS_CODE["RETURN_IN_PROGRESS"] = 151] = "RETURN_IN_PROGRESS";
    STATUS_CODE[STATUS_CODE["COMPLETED"] = 200] = "COMPLETED";
    STATUS_CODE[STATUS_CODE["DFS_DELIVERED"] = 1000] = "DFS_DELIVERED";
    STATUS_CODE[STATUS_CODE["DFS_ON_SCHEDULE"] = 401] = "DFS_ON_SCHEDULE";
})(STATUS_CODE || (STATUS_CODE = {}));
export var FULFILLMENT_TYPE;
(function (FULFILLMENT_TYPE) {
    FULFILLMENT_TYPE["STH"] = "ShipToHome";
    FULFILLMENT_TYPE["BOSS"] = "BuyOnlineShipToStore";
    FULFILLMENT_TYPE["MA"] = "Appliance";
    FULFILLMENT_TYPE["BOPIS"] = "BuyOnlinePickupInStore";
    FULFILLMENT_TYPE["BODFS"] = "BuyOnlineDeliverFromStore";
    FULFILLMENT_TYPE["DFS"] = "DeliverFromStore";
    FULFILLMENT_TYPE["APPLIANCE"] = "Appliance";
    FULFILLMENT_TYPE["MISC"] = "MISC";
    FULFILLMENT_TYPE["CANCEL"] = "CancelledItems";
    FULFILLMENT_TYPE["ADDITIONAL_ITEMS"] = "Additional Items";
    FULFILLMENT_TYPE["ISP"] = "InStorePurchase";
})(FULFILLMENT_TYPE || (FULFILLMENT_TYPE = {}));
export var ORDER_STATUS = {
    STH: {
        101: 'Processing',
        102: 'On its way',
        105: 'Delivered',
        140: '',
    },
    BOSS: {
        101: 'Processing',
        102: '',
        105: 'Your order is ready',
        130: 'On its way to the store',
        131: 'Your order is ready',
        132: 'The store is preparing your order',
        200: 'Picked up',
        140: '',
    },
    BOPIS: {
        101: 'Processing',
        102: '',
        105: 'Your order is ready',
        130: '',
        131: 'Your order is ready',
        200: 'Picked up',
        140: '',
    },
    APPLIANCE: {
        101: 'On schedule',
        102: 'Out for delivery',
        105: 'Delivered',
        108: 'On schedule',
        109: 'Out for delivery',
        110: 'Delivery attempted',
        200: 'Order Completed',
        140: '',
    },
    BODFS: {
        101: 'Processing',
        105: 'Delivered',
        109: 'Out for delivery',
        111: 'On Schedule',
        140: '',
    },
    DFS: {
        101: 'Processing',
        105: 'Delivered',
        109: 'Out for delivery',
        111: 'On Schedule',
        401: 'Processing',
        1000: 'Delivered',
        140: '',
    },
    MISC: {
        101: '',
        102: '',
        105: 'Delivered',
        108: '',
        109: '',
        110: '',
        200: 'Order Completed',
        140: '',
    },
    // Just a placeholder to fix the Lint: this is not required
    CANCEL: {
        101: '',
        102: '',
        105: '',
        108: '',
        109: '',
        110: '',
        200: '',
        140: '',
    },
    ADDITIONAL_ITEMS: {
        101: '',
        102: '',
        105: '',
        108: '',
        109: '',
        110: '',
        200: '',
        140: '',
    },
};
export var ORDER_STATUS_MESSAGE = {
    InStorePurchase: {},
    ShipToHome: {
        101: 'Arriving ',
        102: 'Arriving ',
        103: 'Arriving ',
        104: 'Arriving ',
        105: 'Arrived ',
        150: 'We received your return ',
        151: 'Drop off your package at UPS ',
        140: '',
    },
    BuyOnlineShipToStore: {
        101: 'Ready for Pick up ',
        102: 'Ready for Pick up ',
        103: 'Ready for Pick up ',
        104: 'Ready for Pick up ',
        105: 'Ready for Pick up ',
        130: 'Ready for Pick up ',
        131: 'Ready for Pick up ',
        132: 'Ready for Pick up ',
        150: 'We received your return ',
        151: 'Drop off your package at UPS ',
        200: 'Picked up ',
        140: '',
    },
    BuyOnlinePickupInStore: {
        101: 'Ready by ',
        102: 'Ready by ',
        103: 'Ready by ',
        104: 'Ready by ',
        105: 'Ready by ',
        131: 'Ready by ',
        150: 'We received your return ',
        151: 'Drop off your package at UPS ',
        200: 'Picked up ',
        140: '',
    },
    Appliance: {
        101: 'Delivery Scheduled for ',
        102: 'Delivery Window: ',
        103: 'Delivery Attemped on ',
        104: '',
        105: 'Arrived on ',
        108: 'Delivery Scheduled for ',
        109: 'Delivery Window: ',
        110: 'Delivery Attempted on ',
        150: 'We received your return ',
        151: 'Drop off your package at UPS ',
        200: 'Your Order has Been Completed',
        140: '',
    },
    MISC: {
        101: 'Arriving ',
        102: 'Arriving ',
        103: 'Arriving ',
        104: 'Arriving ',
        105: 'Arrived ',
        150: 'We received your return ',
        151: 'Drop off your package at UPS ',
        140: '',
    },
    BuyOnlineDeliverFromStore: {
        101: 'Delivery Window: ',
        105: 'Delivered ',
        109: 'Delivery Window: ',
        111: 'Delivery Window: ',
        150: 'We received your return ',
        151: 'Drop off your package at UPS ',
        140: '',
    },
    DeliverFromStore: {
        101: 'Delivery Window: ',
        105: 'Delivered ',
        109: 'Delivery Window: ',
        111: 'Delivery Window: ',
        150: 'We received your return ',
        151: 'Drop off your package at UPS ',
        401: 'Delivery Window: ',
        1000: 'Delivered ',
        140: '',
    },
    // just a placeholder
    CancelledItems: {
        101: '',
        105: '',
        109: '',
        111: '',
        150: ' ',
        151: ' ',
        401: '',
        1000: ' ',
        140: '',
    },
    'Additional Items': {
        101: '',
        102: '',
        105: '',
        108: '',
        109: '',
        110: '',
        200: '',
        140: '',
    },
    BACKORDERED: "Unfortunately, these items are currently out of stock. Once shipped,\n  we'll email you the tracking details. Your payment won't be processed\n  until then.",
};
